module.exports = __webpack_public_path__ + "img/album12_05.b4e5f626.jpg";